/**
 * 页面标题栏组件 — 标题 + 面包屑 + 操作区。
 */
import { Box, Typography, Breadcrumbs, Link } from "@mui/material";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

/** 面包屑项。 */
export interface BreadcrumbItem {
  label: string;
  path?: string;
}

export interface PageHeaderProps {
  /** 页面标题。 */
  title: string;
  /** 面包屑（可选）。 */
  breadcrumbs?: BreadcrumbItem[];
  /** 右侧操作区。 */
  actions?: ReactNode;
  /** 副标题。 */
  subtitle?: string;
}

export default function PageHeader({
  title,
  breadcrumbs,
  actions,
  subtitle,
}: PageHeaderProps) {
  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs
          sx={{ mb: 1, fontSize: 12 }}
          separator="›"
        >
          {breadcrumbs.map((item, index) => {
            const isLast = index === breadcrumbs.length - 1;
            if (isLast || !item.path) {
              return (
                <Typography
                  key={index}
                  sx={{ fontSize: 12, color: "text.secondary" }}
                >
                  {item.label}
                </Typography>
              );
            }
            return (
              <Link
                key={index}
                component={RouterLink}
                to={item.path}
                sx={{ fontSize: 12, color: "primary.main", textDecoration: "none" }}
              >
                {item.label}
              </Link>
            );
          })}
        </Breadcrumbs>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography variant="h1" component="h1">
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: 12, color: "text.secondary", mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && <Box>{actions}</Box>}
      </Box>
    </Box>
  );
}
